export default __webpack_public_path__ + "noItems3.16d7438029cbaac9a437eb6764d1b3fd.svg";